export const RefreshRate = {
  '200ms': 200,
  '500ms': 500,
  '1s': 1000,
  '5s': 5000
};

type RefreshRate = typeof RefreshRate[keyof typeof RefreshRate];
